import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import * as styles from './QAndA.css';

const cx = classNames.bind(styles);

export class QAndAItem extends Component {
    static propTypes = {
        item: PropTypes.objectOf(PropTypes.object).isRequired,
    };

    constructor() {
        super();
        this.state = {
            isOpen: false,
        };
    }

    toggleQAndA = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    render() {
        const { item } = this.props;
        const { isOpen } = this.state;

        return (
            <div className={cx('itemWrapper')}>
                <button onClick={this.toggleQAndA} role="button" className={cx('question')}>
                    <div className={cx('toggleIcon', isOpen ? 'close' : '')}>
                        <span className={cx('icon')} />
                    </div>
                    <div className={cx('text')}>{item.question}</div>
                </button>
                <div className={cx('answer', isOpen ? '' : 'hideAnswer')}>{item.answer}</div>
            </div>
        );
    }
}

export default QAndAItem;
